import React from 'react'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { useTranslation } from 'react-i18next'

import { customStyles } from 'components/Sidebar/Styled/CustomStyles'
import { ReportingToolProps } from 'types/Sidebar'
import SubMenu from 'components/Sidebar/Menu/SubMenu'
import bluehavenDomain from 'lib/utility/BluehavenDomain'

const navItems = [
  {
    key: 'forums',
    url: '/admin/reporting/tools/forum_topics',
    dataTestID: 'forums',
  },
  {
    key: 'surveys',
    url: '/admin/reporting/tools/surveys',
    dataTestID: 'surveys',
  },
  {
    key: 'newsFeed',
    url: '/admin/reporting/tools/news_feed',
    dataTestID: 'news-feed',
  },
  {
    key: 'quickPolls',
    url: '/admin/reporting/tools/quick_polls',
    dataTestID: 'quick-polls',
  },
  {
    key: 'guestbook',
    url: '/admin/reporting/tools/guestbook',
    dataTestID: 'guestbook',
  },
  {
    key: 'stories',
    url: '/admin/reporting/tools/stories',
    dataTestID: 'stories',
  },
  {
    key: 'questions',
    url: '/admin/reporting/tools/qanda',
    dataTestID: 'questions',
  },
  {
    key: 'places',
    url: '/admin/reporting/tools/maps',
    dataTestID: 'places',
  },
  {
    key: 'ideas',
    url: '/admin/reporting/tools/brainstormers',
    dataTestID: 'ideas',
  },
]

const ToolReportsMenu = ({
  handleDropdownCollapse,
  isDrawerVisible,
}: ReportingToolProps) => {
  const { t } = useTranslation()

  const renderNavItems = () => {
    const Items = navItems.map(({ key, url, dataTestID }) => {
      return (
        <List
          key={key}
          data-testid={dataTestID}
          sx={{ backgroundColor: '#eeeeee' }}
          disablePadding
        >
          <ListItemButton
            component={'a'}
            href={`${bluehavenDomain()}${url}`}
            key={key}
            sx={customStyles.levelTwoDropdown}
          >
            <ListItemText primary={t(`sidebar.${key}`)} />
          </ListItemButton>
        </List>
      )
    })

    return Items
  }

  return (
    <SubMenu
      dataTestId="tool-report"
      isDrawerVisible={isDrawerVisible}
      keyItem="toolReport"
      name="toolReport"
      handleDropdownCollapse={handleDropdownCollapse}
      listItemStyle={customStyles.listItemButton}
    >
      {renderNavItems()}
    </SubMenu>
  )
}

export default ToolReportsMenu
